'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _actionBar = require('./action-bar');

var _actionBar2 = _interopRequireDefault(_actionBar);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _propTypes = require('./prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PropTypes = _react2['default'].PropTypes;


var SavedTab = _react2['default'].createClass({
    displayName: 'SavedTab',


    propTypes: _extends({}, _propTypes.CommonTabProps, {
        getSignatureUrl: _propTypes.GetSignatureUrl,
        onInsert: PropTypes.func.isRequired,
        onRemove: _react2['default'].PropTypes.func.isRequired,
        onSelect: _react2['default'].PropTypes.func.isRequired,
        selectedSignature: _propTypes.SignatureType,
        signatures: PropTypes.arrayOf(_propTypes.SignatureType).isRequired
    }),

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'canInsertEverywhere': true
        };
    },
    getInitialState: function getInitialState() {

        var carouselLength = this.detectCarouselLength(this.props.deviceOrientation, this.props.screenSize);

        return {
            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
            'carouselLength': carouselLength,
            'carouselRange': [0, carouselLength - 1]
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(newProps) {

        var signatures = newProps.signatures;
        var hasSignatures = signatures && signatures.length > 0;
        var carouselLength = 0;

        if (hasSignatures) {
            carouselLength = this.detectCarouselLength(newProps.deviceOrientation, newProps.screenSize);
        }

        this.setState({
            'carouselLength': carouselLength
        });
    },


    //  ----  BEHAVIOR  -----------------------------------

    insertSignature: function insertSignature(insertEverywhere) {
        var signature = this.props.selectedSignature;

        return this.props.onInsert(signature, insertEverywhere);
    },
    shiftCarousel: function shiftCarousel(dir) {
        var _this = this;

        var range;
        var numItems = this.props.signatures.length;
        var selectedIndex = this.getSelectedCarouselIndex();

        switch (dir) {

            case 'next':
                range = [this.state.carouselRange[0] + 1, Math.min(this.state.carouselRange[1] + 1, numItems - 1)];
                break;

            case 'prev':
                range = [Math.max(0, this.state.carouselRange[0] - 1), this.state.carouselRange[1] - 1];
                break;

            default:
                throw new Error('Invalid direction: ' + dir);
        }

        // Ensure the current selected signature is still visible in the carousel.
        // Find the closest visible if not.
        // var selectedIndex = this.getSelectedCarouselIndex();
        var nextSignature = void 0;

        if (!this.isInCarouselRange(selectedIndex, range)) {
            if (selectedIndex < range[0]) {
                nextSignature = this.props.signatures[range[0]];
            }
            if (selectedIndex > range[1]) {
                nextSignature = this.props.signatures[range[1]];
            }
        }

        this.setState({
            'carouselRange': range
        }, function () {
            if (nextSignature) {
                _this.props.onSelect(nextSignature);
            }
        });
    },


    //  ----  HELPERS  ------------------------------------

    getSelectedCarouselIndex: function getSelectedCarouselIndex() {
        if (typeof this.props.selectedSignature === 'undefined' || this.props.selectedSignature === null) {
            return 0;
        }
        var selectedSignature = this.props.selectedSignature;
        var selectedIndex = 0;
        for (var i = 0; i < this.props.signatures.length; i++) {
            if (this.props.signatures[i].guid === selectedSignature.guid) {
                selectedIndex = i;
                break;
            }
        }
        return selectedIndex;
    },
    detectCarouselLength: function detectCarouselLength(orientation, screenSize) {
        if (screenSize === _constants2['default'].SCREEN_SMALL) {
            if (orientation === _constants2['default'].ORIENTATION_PORTRAIT) {
                // Only show one on small screen when in portrait mode
                return 1;
            } else {
                // But show two when in landscape mode
                return 3;
            }
        } else {
            // Default
            return _constants2['default'].CAROUSEL_LENGTH;
        }
    },
    scaleSignatureToFit: function scaleSignatureToFit(origDims, restrictDims) {
        origDims = Object.assign({}, origDims);
        origDims.ratio = parseFloat(origDims.width / origDims.height);
        if (origDims.width > origDims.height) {
            origDims.width = restrictDims.width;
            origDims.height = parseInt(origDims.width / origDims.ratio, 10);
            if (origDims.height > restrictDims.height) {
                origDims.height = restrictDims.height;
                origDims.width = parseInt(origDims.height * origDims.ratio, 10);
            }
        } else {
            origDims.height = restrictDims.height;
            origDims.width = parseInt(origDims.height * origDims.ratio, 10);
            if (origDims.width > restrictDims.width) {
                origDims.width = restrictDims.width;
                origDims.height = parseInt(origDims.width / origDims.ratio, 10);
            }
        }
        return origDims;
    },
    isInCarouselRange: function isInCarouselRange(i, range) {
        if (range === undefined) {
            range = this.state.carouselRange;
        }
        return i >= range[0] && i <= range[1];
    },


    //  ----  RENDERING  ----------------------------------

    renderSignatureImage: function renderSignatureImage(signature, isThumbnail) {

        if (!signature) return;

        var url = this.props.getSignatureUrl(signature);
        var dims;
        var containerDims = {
            'width': 75,
            'height': 40
        };

        if (isThumbnail) {
            dims = this.scaleSignatureToFit({
                'width': signature.width,
                'height': signature.height
            }, containerDims);
        } else {
            dims = {
                'width': 2 * signature.width,
                'height': 2 * signature.height
            };
        }

        var topMargin = Math.max(0, parseInt((containerDims.height - dims.height) / 2, 10));
        var style = {
            'marginTop': topMargin + 'px',
            'width': dims.width + 'px',
            'height': dims.height + 'px'
        };

        return _react2['default'].createElement('img', {
            src: url,
            style: style });
    },
    renderSignatureCarousel: function renderSignatureCarousel() {
        var onRemove = this.props.onRemove;

        var carouselItems = [];
        var classes;
        var signature;
        var carouselRange = this.state.carouselRange;

        var selectedSignature = this.props.selectedSignature ? this.props.selectedSignature.guid : void 0;

        for (var i = 0; i < this.props.signatures.length; i++) {

            signature = this.props.signatures[i];

            classes = {
                'm-sign-modal--tabs--saved--carousel--item': true,
                'whitelabel-signature-modal-save-carousel-tab-item': true,
                'is-selected': selectedSignature === signature.guid,
                'is-hidden': !this.isInCarouselRange(i, carouselRange)
            };

            carouselItems.push(_react2['default'].createElement(
                'li',
                { key: 'carousel-item-' + i, className: (0, _classnames2['default'])(classes) },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-sign-modal--tabs--saved--carousel--item--content', onClick: this.props.onSelect.bind(null, signature) },
                    this.renderSignatureImage(signature, true)
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-sign-modal--tabs--saved--carousel--item--delete', onClick: onRemove.bind(null, signature) },
                    _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.saved.delete.linkText' })
                )
            ));
        }

        classes = {
            'm-sign-modal--tabs--saved--carousel--list': true,
            'with-arrows': this.props.signatures.length > _constants2['default'].CAROUSEL_LENGTH
        };

        if (carouselRange[0] > 0) {
            leftArrow = _react2['default'].createElement('li', {
                'data-test-ref': 'signature-carousel-left-arrow',
                className: 'm-sign-modal--tabs--saved--carousel--arrow prev',
                onClick: this.shiftCarousel.bind(null, 'prev') });
        }

        // Arrows
        var leftArrowEnabled = carouselRange[0] > 0;
        var rightArrowEnabled = carouselRange[1] < this.props.signatures.length - 1;
        var leftArrow = _react2['default'].createElement('li', {
            'data-test-ref': 'signature-carousel-left-arrow',
            className: (0, _classnames2['default'])({
                'm-sign-modal--tabs--saved--carousel--arrow': true,
                'prev': true,
                'is-disabled': !leftArrowEnabled
            }), onClick: leftArrowEnabled ? this.shiftCarousel.bind(null, 'prev') : null });
        var rightArrow = _react2['default'].createElement('li', {
            'data-test-ref': 'signature-carousel-right-arrow',
            className: (0, _classnames2['default'])({
                'm-sign-modal--tabs--saved--carousel--arrow': true,
                'next': true,
                'is-disabled': !rightArrowEnabled
            }), onClick: rightArrowEnabled ? this.shiftCarousel.bind(null, 'next') : null });

        return _react2['default'].createElement(
            'div',
            {
                className: 'm-sign-modal--tabs--saved--carousel--clip',
                'data-test-ref': 'signature-carousel' },
            _react2['default'].createElement(
                'ul',
                { className: (0, _classnames2['default'])(classes) },
                leftArrow,
                carouselItems,
                rightArrow
            )
        );
    },
    renderSignatureList: function renderSignatureList() {

        var listItems = [];
        var classes;
        var isSelected;
        var signature;
        var deleteBtn;
        var onRemove = this.props.onRemove;


        var selectedSignature = this.props.selectedSignature ? this.props.selectedSignature.guid : void 0;

        for (var i = 0; i < this.props.signatures.length; i++) {

            signature = this.props.signatures[i];
            isSelected = signature.guid === selectedSignature;
            deleteBtn = isSelected ? _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--tabs--saved--list--item--delete', onClick: onRemove.bind(null, signature) },
                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.saved.delete.linkText' })
            ) : null;
            classes = {
                'm-sign-modal--tabs--saved--list--item': true,
                'is-selected': isSelected
            };
            listItems.push(_react2['default'].createElement(
                'div',
                { key: 'sig-' + i, className: (0, _classnames2['default'])(classes), onClick: this.props.onSelect.bind(null, signature) },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-sign-modal--tabs--saved--list--item--image' },
                    this.renderSignatureImage(signature)
                ),
                deleteBtn
            ));
        }

        return _react2['default'].createElement(
            'div',
            { className: 'm-sign-modal--tabs--saved--list', 'data-test-ref': 'signature-list' },
            listItems
        );
    },
    render: function render() {
        var actionBarProps = this.props.actionBarProps;

        var emptyMessage;
        var featuredSignature;
        var carousel;
        var carouselTip;
        var tabTitle;
        var hasSignatures = this.props.signatures.length;

        if (hasSignatures) {

            if (this.props.isMobile) {

                // Render the list of signatures
                carousel = this.renderSignatureList();
            } else {

                tabTitle = _react2['default'].createElement(
                    'span',
                    { className: 'm-sign-modal--tabs--tab-title' },
                    _react2['default'].createElement(_reactIntl.FormattedMessage, {
                        id: 'signModal.saved.title',
                        values: { type: this.props.type }
                    })
                );

                // Featured signature or initials
                featuredSignature = _react2['default'].createElement(
                    'div',
                    { className: 'm-sign-modal--tabs--saved--featured' },
                    this.renderSignatureImage(this.props.selectedSignature)
                );

                // Carousel tip
                carouselTip = _react2['default'].createElement(
                    'div',
                    { className: 'm-sign-modal--tabs--saved--carousel--tip' },
                    _react2['default'].createElement(
                        'p',
                        null,
                        _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.saved.tip.label' }),
                        ': ',
                        _react2['default'].createElement('br', null),
                        _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.saved.tip.text', values: { type: this.props.type } })
                    )
                );

                // Carousel
                carousel = _react2['default'].createElement(
                    'div',
                    { className: 'm-sign-modal--tabs--saved--carousel' },
                    carouselTip,
                    this.renderSignatureCarousel()
                );
            }
        } else {

            // No signatures or initials
            emptyMessage = _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--tabs--saved--empty', 'data-test-ref': 'empty-message' },
                _react2['default'].createElement(
                    'h2',
                    null,
                    _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.saved.empty.text', values: { type: this.props.type } })
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.saved.empty.subText', values: { type: this.props.type } })
                )
            );
        }

        var containerClasses = {
            'm-sign-modal--tabs--tab': true,
            'is-selected': this.props.isSelected
        };

        containerClasses[_constants2['default'].TAB_SAVED] = true;

        var classes = {
            'm-sign-modal--tabs--saved': true,
            'has-signatures': this.props.signatures.length
        };

        return _react2['default'].createElement(
            'div',
            { className: (0, _classnames2['default'])(containerClasses) },
            tabTitle,
            _react2['default'].createElement(
                'div',
                { className: (0, _classnames2['default'])(classes) },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-sign-modal--tabs--content', ref: this.props.captureTabContentRef },
                    emptyMessage,
                    featuredSignature,
                    carousel
                )
            ),
            _react2['default'].createElement(_actionBar2['default'], _extends({
                'data-test-ref': 'action-bar'
            }, actionBarProps, {
                onInsert: this.insertSignature,
                disableButtons: !hasSignatures
            }))
        );
    }
});

module.exports = SavedTab;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/saved-tab.jsx
 ** module id = 795
 ** module chunks = 0 1
 **/